import React from "react";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
    const { t } = useTranslation();

    return (
        <span>
            {/* <p className="last-p"><b>{t("웹_개인정보처리방침", { ns: "policy" })}</b></p> */}
            <p className="last-p">{t("웹_개인정보처리방침_0_서문_1", { ns: "policy" })}</p>
            <p className="last-p">{t("웹_개인정보처리방침_0_서문_2", { ns: "policy" })}</p>

            <h3>{t("웹_개인정보처리방침_1_제목", { ns: "policy" })}</h3>

            <p className="last-p">
                <b>{t("웹_개인정보처리방침_1_1_제목", { ns: "policy" })}</b><br />
                {t("웹_개인정보처리방침_1_1_내용", { ns: "policy" })}
            </p>
            {/* <p className="last-p">{t("웹_개인정보처리방침_1_1_내용", { ns: "policy" })}</p> */}

            <p className="last-p">
                <b>{t("웹_개인정보처리방침_1_2_제목", { ns: "policy" })}</b><br />
                {t("웹_개인정보처리방침_1_2_내용_1", { ns: "policy" })}<br /><br />
                <ul className="last-p">
                    <li>{t("웹_개인정보처리방침_1_2_내용_2", { ns: "policy" })}</li>
                    <li>{t("웹_개인정보처리방침_1_2_내용_3", { ns: "policy" })}</li>
                    <li>{t("웹_개인정보처리방침_1_2_내용_4", { ns: "policy" })}</li>
                    <li>{t("웹_개인정보처리방침_1_2_내용_5", { ns: "policy" })}</li>
                    <li>{t("웹_개인정보처리방침_1_2_내용_6", { ns: "policy" })}</li>
                </ul>
                {t("웹_개인정보처리방침_1_2_내용_7", { ns: "policy" })}
            </p>
            {/* <ul className="last-p">
                <li>{t("웹_개인정보처리방침_1_2_내용_2", { ns: "policy" })}</li>
                <li>{t("웹_개인정보처리방침_1_2_내용_3", { ns: "policy" })}</li>
                <li>{t("웹_개인정보처리방침_1_2_내용_4", { ns: "policy" })}</li>
                <li>{t("웹_개인정보처리방침_1_2_내용_5", { ns: "policy" })}</li>
                <li>{t("웹_개인정보처리방침_1_2_내용_6", { ns: "policy" })}</li>
            </ul>
            <p className="last-p">{t("웹_개인정보처리방침_1_2_내용_7", { ns: "policy" })}</p> */}

            <p className="last-p">
                <b>{t("웹_개인정보처리방침_1_3_제목", { ns: "policy" })}</b><br />
                {t("웹_개인정보처리방침_1_3_내용_1", { ns: "policy" })}<br />
                {t("웹_개인정보처리방침_1_3_내용_2", { ns: "policy" })}
            </p>
            {/* <p className="last-p">{t("웹_개인정보처리방침_1_3_내용_1", { ns: "policy" })}</p> */}
            {/* <p className="last-p">{t("웹_개인정보처리방침_1_3_내용_2", { ns: "policy" })}</p> */}

            <h3>{t("웹_개인정보처리방침_2_제목", { ns: "policy" })}</h3>
            <p>
                {t("웹_개인정보처리방침_2_내용_1", { ns: "policy" })}<br /><br />
                <ul className="last-p">
                    <li>{t("웹_개인정보처리방침_2_내용_2", { ns: "policy" })}</li>
                    <li>{t("웹_개인정보처리방침_2_내용_3", { ns: "policy" })}</li>
                    <li>{t("웹_개인정보처리방침_2_내용_4", { ns: "policy" })}</li>
                </ul>
            </p>
            {/* <ul className="last-p">
                <li>{t("웹_개인정보처리방침_2_내용_2", { ns: "policy" })}</li>
                <li>{t("웹_개인정보처리방침_2_내용_3", { ns: "policy" })}</li>
                <li>{t("웹_개인정보처리방침_2_내용_4", { ns: "policy" })}</li>
            </ul> */}

            <h3>{t("웹_개인정보처리방침_3_제목", { ns: "policy" })}</h3>
            <p className="last-p">
                {t("웹_개인정보처리방침_3_내용_1", { ns: "policy" })}
                {t("웹_개인정보처리방침_3_내용_2", { ns: "policy" })}
                {t("웹_개인정보처리방침_3_내용_3", { ns: "policy" })}
            </p>
            {/* <p className="last-p">{t("웹_개인정보처리방침_3_내용_2", { ns: "policy" })}</p>
            <p className="last-p">{t("웹_개인정보처리방침_3_내용_3", { ns: "policy" })}</p> */}

            <h3>{t("웹_개인정보처리방침_4_제목", { ns: "policy" })}</h3>
            <p className="last-p">
                {t("웹_개인정보처리방침_4_내용_1", { ns: "policy" })}
                {t("웹_개인정보처리방침_4_내용_2", { ns: "policy" })}
            </p>
            {/* <p className="last-p">{t("웹_개인정보처리방침_4_내용_2", { ns: "policy" })}</p> */}

            <h3>{t("웹_개인정보처리방침_5_제목", { ns: "policy" })}</h3>
            <p>
                {t("웹_개인정보처리방침_5_내용_1", { ns: "policy" })}<br /><br />
                <ul className="last-p">
                    <li>{t("웹_개인정보처리방침_5_항목_1", { ns: "policy" })}</li>
                    <li>{t("웹_개인정보처리방침_5_항목_2", { ns: "policy" })}</li>
                    <li>{t("웹_개인정보처리방침_5_항목_3", { ns: "policy" })}</li>
                    <li>{t("웹_개인정보처리방침_5_항목_4", { ns: "policy" })}</li>
                </ul>
            </p>
            {/* <ul className="last-p">
                <li>{t("웹_개인정보처리방침_5_항목_1", { ns: "policy" })}</li>
                <li>{t("웹_개인정보처리방침_5_항목_2", { ns: "policy" })}</li>
                <li>{t("웹_개인정보처리방침_5_항목_3", { ns: "policy" })}</li>
                <li>{t("웹_개인정보처리방침_5_항목_4", { ns: "policy" })}</li>
            </ul> */}

            <h3>{t("웹_개인정보처리방침_6_제목", { ns: "policy" })}</h3>
            <p className="last-p">{t("웹_개인정보처리방침_6_내용", { ns: "policy" })}</p>

            <h3>{t("웹_개인정보처리방침_7_제목", { ns: "policy" })}</h3>
            <p className="last-p">{t("웹_개인정보처리방침_7_내용", { ns: "policy" })}</p>

            <h3>{t("웹_개인정보처리방침_8_제목", { ns: "policy" })}</h3>
            <p className="last-p">
                {t("웹_개인정보처리방침_8_내용_1", { ns: "policy" })}
                {t("웹_개인정보처리방침_8_내용_2", { ns: "policy" })}
                {t("웹_개인정보처리방침_8_내용_3", { ns: "policy" })}
            </p>
            {/* <p className="last-p">{t("웹_개인정보처리방침_8_내용_2", { ns: "policy" })}</p> */}
            {/* <p className="last-p">{t("웹_개인정보처리방침_8_내용_3", { ns: "policy" })}</p> */}

            <h3>{t("웹_개인정보처리방침_9_제목", { ns: "policy" })}</h3>
            <p className="last-p">{t("웹_개인정보처리방침_9_내용", { ns: "policy" })}</p>
        </span>
    );
};

export default PrivacyPolicy;
